/* eslint-disable jsx-a11y/anchor-is-valid */
import { Card } from '@pmi/dsm-react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { EditIcon } from '@pmi/dsm-react/dist/components/icons/fa/16';

import { accountSelector } from '../../../shared/store/shared/accountSlice';
import { useGetAccountDataQuery } from '../../../shared/navigation/apiSlice';
import usePermissions from '../../../shared/hooks/usePermissions';
import PERMISSIONS from '../../../shared/permissions';
import EditAccountNameModal from './EditAccountNameModal';
import styles from './accountName.module.scss';

export default function AccountName() {
  const [showEditAccountNameModal, setShowEditAccountNameModal] =
    useState<boolean>(false);
  const { currentAccountId } = useSelector(accountSelector);
  const {
    data: accountData,
    isLoading,
    isFetching,
  } = useGetAccountDataQuery(currentAccountId);
  const { hasAccess } = usePermissions();
  const editAccountVisible = hasAccess({
    permissions: [PERMISSIONS.UpdateAccountName],
  });

  return (
    <>
      <Card className="p-0">
        <div className="p-4">
          <div className="d-flex flex-column">
            <div className="flex-fill">
              <h4 className="fw-bold mb-0">Account Name</h4>
            </div>

            {(isLoading || isFetching) && (
              <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                <Spinner />
              </div>
            )}
            {!isLoading && !isFetching && (
              <div className="row gx-2 align-items-center">
                <div className="col-auto">
                  <span className={styles.accountNameTitle}>
                    {accountData?.name}
                  </span>
                </div>
                {editAccountVisible && (
                  <div className="col-auto align-items-center d-flex">
                    <a
                      href="#"
                      className={`${styles.editLink} d-inline-flex`}
                      onClick={(e) => {
                        e.preventDefault();
                        setShowEditAccountNameModal(true);
                      }}
                    >
                      <EditIcon
                        className="align-items-start me-1 align-self-center"
                        fontSize="xs"
                      />
                      <span>Edit Account Name</span>
                    </a>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </Card>
      {showEditAccountNameModal && (
        <EditAccountNameModal
          account={accountData}
          onCancel={() => setShowEditAccountNameModal(false)}
        />
      )}
    </>
  );
}
